module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [(_vm.dataReady) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header clearfix"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [(_vm.canBorrow) ? _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#borrowModal",
      "title": "Заеми"
    }
  }, [_c('i', {
    staticClass: "fa fa-book"
  }), _vm._v("Заеми\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Назад",
      "to": "/book/list"
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })]), _vm._v(" "), (_vm.isOwner) ? _c('router-link', {
    staticClass: "btn btn-info",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Редактирай",
      "to": '/book/' + _vm.book.id + '/edit'
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]) : _vm._e()], 1)])]) : _vm._e()]), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header clearfix"
  }, [_c('h4', {
    staticClass: "card-title pull-left"
  }, [_c('img', {
    staticStyle: {
      "width": "40px",
      "margin-right": "1rem"
    },
    attrs: {
      "src": _vm.book.image || '/network/static/img/default.jpg'
    }
  }), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.book.title) + "\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "w-25"
  }, [_vm._v("Автор:")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.book.author) + "\n\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Издателство:")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.book.publisher) + "\n\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Описание:")]), _vm._v(" "), _c('td', [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$options.filters.nl2br(_vm.book.description))
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Език:")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$config.lists.languages[_vm.book.language].text) + "\n\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Статус:")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "clearfix"
  }, [_c('span', {
    staticClass: "float-left",
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.$config.lists.bookStatuses[_vm.book.status].text))]), _vm._v(" "), (_vm.isStatusChangeable) ? _c('div', [_vm._m(0)]) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Принадлежи на семейство:")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "clearfix"
  }, [_c('c-avatar', {
    staticClass: "float-left",
    attrs: {
      "family": _vm.book.family,
      "show-name": true
    }
  })], 1)])]), _vm._v(" "), (_vm.book.status == 'requested' && _vm.book.taker) ? _c('tr', [_c('td', [_vm._v("Поискана от семейство:"), _c('br'), _c('span', [_vm._v("(до " + _vm._s(_vm._f("prettyDate")(_vm.book.takerDueDate)) + ")")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "clearfix"
  }, [_c('c-avatar', {
    staticClass: "float-left",
    attrs: {
      "family": _vm.book.taker,
      "show-name": true
    }
  }), _vm._v(" "), (_vm.isRequested) ? _c('div', [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Одобрявам"
    },
    on: {
      "click": function($event) {
        _vm.onApproveRequest()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Одобрявам")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Не одобрявам"
    },
    on: {
      "click": function($event) {
        _vm.onRejectRequest()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Не одобрявам")])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.book.status == 'taken') ? _c('tr', [_c('td', [_vm._v("Дадена на семейство:"), _c('br'), _c('span', [_vm._v("(до " + _vm._s(_vm._f("prettyDate")(_vm.book.takerDueDate)) + ")")])]), _vm._v(" "), _c('td', [(_vm.book.taker) ? _c('div', {
    staticClass: "clearfix"
  }, [_c('c-avatar', {
    staticClass: "float-left",
    attrs: {
      "family": _vm.book.taker,
      "show-name": true
    }
  })], 1) : _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.book.takerExternal) + "\n\t\t\t\t\t\t\t\t\t\t")])])]) : _vm._e()])])])])]), _vm._v(" "), _c('f-modal', {
    attrs: {
      "id": "borrowModal",
      "large": true,
      "cancel-text": "Отказ"
    },
    on: {
      "ok": _vm.onBorrowBook
    }
  }, [_c('h5', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Поискване на книга")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', [_vm._v("Период, за който искате да използвате тази книга:")]), _vm._v(" "), _c('div', [_c('f-radio', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "borrowPeriod",
      "radios": _vm.$config.lists.borrowPeriods
    },
    model: {
      value: (_vm.borrowPeriod),
      callback: function($$v) {
        _vm.borrowPeriod = $$v
      },
      expression: "borrowPeriod"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('p', {
    staticClass: "alert alert-warning"
  }, [_vm._v("Семейството, което притежава книгата може да одобри или отхвърли заявката."), _c('br'), _vm._v("При одобрение двете семейства трябва да се разберат допълнително за самото изпращане на книгата.")])])])])]), _vm._v(" "), _c('f-modal', {
    attrs: {
      "id": "changeModal",
      "large": true,
      "cancel-text": "Отказ"
    },
    on: {
      "ok": _vm.onChangeStatus
    }
  }, [_c('h5', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Промяна на статуса на книгата")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', [_c('f-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "book_status",
      "errors": _vm.errorBag.collect('book_status'),
      "values": _vm.$config.lists.bookStatuses
    },
    model: {
      value: (_vm.bookStatus),
      callback: function($$v) {
        _vm.bookStatus = $$v
      },
      expression: "bookStatus"
    }
  })], 1)])]), _vm._v(" "), (_vm.bookStatus === 'taken') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_c('f-radio', {
    attrs: {
      "name": "takerType",
      "radios": _vm.takerTypes
    },
    model: {
      value: (_vm.takerType),
      callback: function($$v) {
        _vm.takerType = $$v
      },
      expression: "takerType"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.takerType == 1) ? _c('div', [_c('f-family', {
    attrs: {
      "cplaceholder": "Въведете име на семейство от мрежата"
    },
    model: {
      value: (_vm.takerInternal),
      callback: function($$v) {
        _vm.takerInternal = $$v
      },
      expression: "takerInternal"
    }
  })], 1) : _c('div', [_c('f-input', {
    attrs: {
      "cplaceholder": "Въведете име"
    },
    model: {
      value: (_vm.takerExternal),
      callback: function($$v) {
        _vm.takerExternal = $$v
      },
      expression: "takerExternal"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.bookStatus === 'taken') ? _c('div', [_vm._v("\n\t\t\t\t\tПериод, за който искате да дадете книгата:\n\t\t\t\t\t"), _c('div', [_c('f-radio', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "borrowPeriod",
      "radios": _vm.$config.lists.borrowPeriods
    },
    model: {
      value: (_vm.borrowPeriod),
      callback: function($$v) {
        _vm.borrowPeriod = $$v
      },
      expression: "borrowPeriod"
    }
  })], 1)]) : _vm._e()])])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#changeModal"
    }
  }, [_c('i', {
    staticClass: "fa fa-book"
  }), _vm._v(" Промени")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-22bff6ed!./~/vue-loader/lib/selector.js?type=template&index=0!./~/htmlhint-loader?{"configFile":".htmlhintrc.json","failOnError":true}!./src/components/share/BookView.vue
// module id = 643
// module chunks = 1